import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';

const Footer = styled(MuiAppBar, { shouldForwardProp: prop => prop !== 'open' })(({ theme }) => ({
    background: theme.palette.fancy.main,
    width: '100%',
}));

export default Footer; 